import getRelatedCodesForError, { ErrorLike } from './getRelatedCodesForError';
import getActionType from './getActionType';

type FlowNode = {
  action?: string;
  selected_api?: string;
  type_of?: string;
};

const getTroubleshootingVariables = (error?: ErrorLike, node?: FlowNode) => {
  const variables: {
    app?: string;
    actionType?: string;
    appAction?: string;
    relatedCodes?: string[];
  } = {};

  if (node) {
    if (node.selected_api) {
      variables.app = node.selected_api;
    }
    const actionType = getActionType(node.type_of);
    if (actionType) {
      variables.actionType = actionType;
    }
    if (node.selected_api) {
      variables.appAction = node.action;
    }
  }

  if (error) {
    const relatedCodes = getRelatedCodesForError(error);

    if (relatedCodes.length !== 0) {
      variables.relatedCodes = relatedCodes;
    }
  }

  return variables;
};

export default getTroubleshootingVariables;
